var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeIn"}},[(_vm.showHide)?_c('div',{staticClass:"preloader",class:[_vm.className, { 'preloader-transparent': _vm.transparent }]},[_c('div',{staticClass:"preloader-box"},[_c('img',{attrs:{"src":require("@/assets/preloader.png"),"alt":"preloader"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }